import { render, staticRenderFns } from "./StudentsWithoutContactNotes.vue?vue&type=template&id=422b5638&scoped=true&"
import script from "./StudentsWithoutContactNotes.vue?vue&type=script&lang=js&"
export * from "./StudentsWithoutContactNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422b5638",
  null
  
)

export default component.exports